// extracted by mini-css-extract-plugin
export default {"container":"Imagem_container__AJSWP","imagem":"Imagem_imagem__R0bRM","info":"Imagem_info__Sui+z","descricao":"Imagem_descricao__B2op6","opcoes":"Imagem_opcoes__aVt1n"};